import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/stores/auth'
import { tenantsAPI } from '@/api/client'
import { isSuperAdmin } from '@/lib/role'
import type { AccessibleTenant } from '@/types'

/**
 * Keeps the auth store's `tenants` (the companies a member can switch between)
 * in sync with the server, so a membership a super admin assigns mid-session
 * shows up without a re-login. Super admins switch via the all-tenants list and
 * are skipped here.
 */
export function useMyTenants() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const role = useAuthStore((s) => s.user?.role)
  const setTenants = useAuthStore((s) => s.setTenants)
  const enabled = isAuthenticated && !isSuperAdmin(role)

  const { data } = useQuery<AccessibleTenant[]>({
    queryKey: ['my-tenants'],
    queryFn: tenantsAPI.myTenants,
    enabled,
    staleTime: 60_000,
  })

  useEffect(() => {
    if (data) setTenants(data)
  }, [data, setTenants])
}
